/* unplugin-vue-components disabled */import script from "./CommonModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonModal.vue?vue&type=script&setup=true&lang=ts"

import "./CommonModal.vue?vue&type=style&index=0&id=a41c0372&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a41c0372"]])

export default __exports__